import React, { useState } from "react";
import "./App.css";
import rungneLogo from "./Rungne-PrimaryLogo-Icecap-Large.png";

function App() {
  const [input, setInput] = useState("");
  const [items, setItems] = useState([]);
  const [winner, setWinner] = useState(null);

  const handleAdd = () => {
    if (input.trim() !== "") {
      setItems([...items, input.trim()]);
      setInput("");
    }
  };

  const handleShuffle = () => {
    if (items.length > 0) {
      const randomIndex = Math.floor(Math.random() * items.length);
      setWinner(items[randomIndex]);
    }
  };

  const handleReset = () => {
    setItems([]);
    setWinner(null);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleAdd();
    }
  };

  return (
    <div className="container">
      {/* Headline Logo */}
      <img src={rungneLogo} alt="Rungne Logo" className="logo" />

      {/* Input Section */}
      <div className="input-container">
        <input
          type="text"
          placeholder="Enter a string"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <button onClick={handleAdd}>Add</button>
      </div>

      <div className="input-container">
        {/* List of Items */}
        <ul className="item-list">
          {items.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </div>

      {/* Buttons Container */}
      <div className="buttons-container">
        <button className="shuffle-btn" onClick={handleShuffle}>
          Pick Winner
        </button>
        <button className="reset-btn" onClick={handleReset}>
          Reset
        </button>
      </div>

      {/* Winner Display */}
      {winner && (
        <div className="input-container">
          <div className="winner">
            <h2>Winner:</h2>
            <p>{winner}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
